import AcadlyLogo from '../../../../icons/AcadlyLogoSquare';
import PollActions, { PollActionsProps } from './PollActions';
import PollTitle, { PollTitleProps } from './PollTitle';
import { headerClasses, Root } from './styles';

export interface HeaderProps extends PollTitleProps, PollActionsProps {}

const Header = ({ formMethods, onSubmit, onLocalSubmit, triggerValidations, errors }: HeaderProps) => {
  return (
    <Root>
      <AcadlyLogo size={48} />
      <PollTitle
        formMethods={formMethods}
        onSubmit={onSubmit}
        onLocalSubmit={onLocalSubmit}
        className={headerClasses.titleForm}
      />
      <PollActions triggerValidations={triggerValidations} errors={errors} />
    </Root>
  );
};

export default Header;
